module.exports = __webpack_public_path__ + "img/icon-star-inactive.f5a8e425.svg";